<template>
  <v-layout row wrap>
    <v-flex px-1 py-1 shrink>
      <SimpleTextInput
          v-model="bookingForm.booking.business_customer_name"
          width="120px"
          label="Lead PAX Name"
          :error="bookingForm.errors.business_customer_name"
      />
    </v-flex>
    <v-flex shrink py-1 px-1>
      <v-row>
        <v-flex shrink>
          <SimpleTextInput
              v-model="bookingForm.booking.business_customer_number"
              label="Contact No."
              width="120px"
          />
        </v-flex>
        <v-flex
            v-if="bookingForm.booking.business_customer_number != null && bookingForm.booking.business_customer_number != ''"
        >
          <a
              style="font-size: 12px;"
              :href="'tel:' + formatNumber(bookingForm.booking.business_customer_number)"
          >
            <v-btn class="small-fab-phone" icon text @click="addingCard = false">
              <v-icon>phone</v-icon>
            </v-btn>
          </a>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex py-1 shrink px-1>
      <SimpleTextInput
          width="160px"
          v-model="bookingForm.booking.business_customer_email"
          label="Email"
          :error="bookingForm.errors.business_customer_email"
      />
    </v-flex>
    <v-flex py-1 px-1 shrink>
      <SimpleTextInput
          v-model="bookingForm.booking.business_customer_reference"
          label="REF"
          width="100px"
          :error="bookingForm.errors.business_customer_reference"
      />
    </v-flex>
    <v-flex py-1 px-1 shrink>
      <SimpleTextInput
          v-if="!hideAuthorizedBy"
          :error="bookingForm.errors.authorized_by"
          v-model="bookingForm.booking.authorized_by"
          label="Authorized By"
          width="100px"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";

import { replaceStart } from "@/components/util/PhoneNumbers.js";

export default {
  name: "BusinessCustomerDetailsInput",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingDateInput,
    SimpleTextInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAuthorizedBy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      userRules: {
        name: [
          (v) => !!v || "Name is required",
          (v) => (v && v.length <= 100) || "Name cannot exceed 100 characters",
        ],
        authorized_by: [
          (v) => !!v || "Field is required",
          (v) => (v && v.length <= 100) || "Field cannot exceed 100 characters",
        ],
        reference_number: [
          (v) => !!v || "Ref is required",
          (v) => (v && v.length <= 100) || "Ref cannot exceed 100 characters",
        ],
        email: [(v) => !v || /^.+@.+/.test(v) || "Email must be valid"],
        contact_number: [
          (v) => !!v || "Mobile number is required",
          (v) => /^\+?[0-9]{6,15}$/.test(v) || "Phone number must be valid",
        ],
      },
    };
  },
  computed: {
  
  },
  methods: {
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
